import React, { useMemo, useState } from 'react'
import LayoutForm from '../../../containers/layouts/LayoutForm'
import { Alert, Card, CardBody } from 'react-bootstrap'
import { Header } from '../../../components/Containers/Header'
import { Lista, ModalAlteracionMenstruales, Option } from './components'
import { activarModalGenerico, clearActiveAlterationMenstrual } from '../../../store/slices/uiSlice'
import { useDispatch } from 'react-redux'
import { ACTIONS, modules, PERMISSIONS } from '../../../constants'
import { toastAdapter } from '../../../plugins'
import {
  useAddMenstruationMutation,
  useUpdateMenstruationMutation
} from '../../../services/rtk-query'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { genericFormSchema } from '../../../utils'
import { usePermissions } from '../../../hooks'

export const AlteraicionMenstrualesPage = () => {
  const { hasPermission } = usePermissions()
  const dispatch = useDispatch()
  const [action, setAction] = useState(ACTIONS.SAVE)
  const [addMenstruacion] = useAddMenstruationMutation()
  const [updateMenstruacion] = useUpdateMenstruationMutation()
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(genericFormSchema),
    defaultValues: {
      nombre: '',

      id: 0
    }
  })
  const columns = useMemo(
    () => [
      {
        header: 'id',
        accessorKey: 'id'
      },
      {
        header: 'nombre',
        accessorKey: 'nombre'
      },
      {
        header: 'Activo',
        accessorKey: 'activo',
        cell: ({ row: { original } }) =>
          original.activo ? (
            <Alert
              variant="primary"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              Si
            </Alert>
          ) : (
            <Alert
              variant="danger"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              No
            </Alert>
          )
      },
      {
        header: 'Opciones',
        accessorKey: 'id',
        cell: ({ row: { original } }) => (
          <Option
            hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.alteraciones_menstruales)}
            cell={original.id}
            setAction={setAction}
            activo={original.activo}
          />
        )
      }
    ],
    []
  )
  const handler = () => {
    dispatch(activarModalGenerico())
  }

  const handlerAction = (data) => {
    if (action === ACTIONS.SAVE) return handleSave(data)

    return handleUpdate(data)
  }

  const handleSave = (data) => {
    const { id, ...rest } = data
    toastAdapter.promise({
      promise: addMenstruacion(rest).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)

        return 'Alteracion Menstrual guardado con éxito'
      },
      errorMessage: 'Error al guardar la Alteracion Menstrual',
      loadingMessage: 'Guardando Alteracion Menstrual...'
    })
  }

  const handleUpdate = (data) => {
    toastAdapter.promise({
      promise: updateMenstruacion({ ...data, id: +getValues('id') }).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)
        dispatch(clearActiveAlterationMenstrual())
        return 'Alteracion Menstrual guardado con éxito'
      },
      errorMessage: 'Error al guardar la Alteracion Menstrual',
      loadingMessage: 'Guardando Alteracion Menstrual...'
    })
  }
  const handleReset = () => {
    reset()
    setAction(ACTIONS.SAVE)
    dispatch(clearActiveAlterationMenstrual())
  }

  return (
    <LayoutForm title="Alteraciones Menstruales">
      <Card className="shadow-none">
        <Header
          title="Alteraciones"
          subtitle="Menstruales"
          buttonTitle="Nueva Alteracion Menstrual"
          handler={handler}
          hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.alteraciones_menstruales)}
        />
        <CardBody>
          <Lista columns={columns} />
        </CardBody>
      </Card>
      <ModalAlteracionMenstruales
        Menstruales
        action={action}
        control={control}
        errors={errors}
        handlerAction={handlerAction}
        handleSubmit={handleSubmit}
        reset={handleReset}
        setValue={setValue}
      />
    </LayoutForm>
  )
}
